var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SModalCentered", {
    key: _vm.companySelected?.id,
    attrs: {
      title: _vm.$t("sEditRates.editRates"),
      isOpen: _vm.isOpen,
      closeModal: _vm.onCancel,
      customProps: { bodyPaddingY: 0, fullWidthFooter: true },
      persistent: true,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "d-flex flex-column" },
              [
                _c("div", { staticClass: "mb-4 d-flex flex-column" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-body-1-bold text--text text--base mb-2",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.companySelected?.name +
                              ", " +
                              _vm.companySelected?.city || ""
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "text-body-2 text--text text--base" },
                    [
                      _vm._v(
                        " CIF: " + _vm._s(_vm.companySelected?.cif || "") + " "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.ratesForm, function (rate, idx) {
                  return _c(
                    "div",
                    { key: rate.seniority, staticClass: "rate-row mb-4" },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "rate-label text-body-1 text--text text--base",
                          attrs: { for: rate.seniority },
                        },
                        [_vm._v(_vm._s(rate.seniorityLabel) + ":")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        {
                          staticClass: "rate-input-row",
                          attrs: { "no-gutters": "" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "input-background rate-input-col",
                              attrs: { "data-cy": "company-rate-input" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-with-unit" },
                                [
                                  _c("SInputNumber", {
                                    attrs: {
                                      value: rate.value,
                                      onChange: (val) =>
                                        _vm.onRateChange(val, idx),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "rate-unit text-body-2 text--text text--base",
                                    },
                                    [_vm._v("€/h")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "v-container",
              { staticClass: "pa-0" },
              [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "mr-6" },
                      [
                        _c("SButton", {
                          attrs: {
                            action: _vm.onCancel,
                            btnStyle: "tertiary",
                            sText: "sEditRates.cancelButton",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      [
                        _c("SButton", {
                          attrs: {
                            action: _vm.onSave,
                            btnStyle: "primary",
                            sText: "sEditRates.saveButton",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }